import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Facebook } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export default function LocationsContact() {
  const { t } = useLanguage();

  const locations = [
    { name: 'Oceans 13 & Demolition — Rycom Mall', address: '〒901-2306 Okinawa, Kitanakagusuku 1 Raikamu', mapUrl: 'https://www.google.com/maps/place/%E3%82%A4%E3%82%AA%E3%83%B3%E3%83%A2%E3%83%BC%E3%83%AB%E6%B2%96%E7%B8%84%E3%83%A9%E3%82%A4%E3%82%AB%E3%83%A0/@26.3137504,127.7944138,17z', room: t('bankHeistSurvival') },
    { name: 'Pirates — Okinawa City Gate 2', address: '〒904-0004 コザ花園、Okinawa, Chūō, 1-chōme−10', mapUrl: 'https://www.google.com/maps/dir/26.342088,127.798149/26.3362873,127.7996337/', room: t('pirateShipExperience') },
  ];

  const contacts = [
    { icon: Mail, label: 'info@okiescape.com', href: 'mailto:info@okiescape.com' },
    { icon: Phone, label: '098-989-0319', href: 'tel:098-989-0319' },
    { icon: Facebook, label: 'Facebook', href: 'http://facebook.com/okiescape' },
  ];

  return (
    <section id="locations" data-testid="locations-section" className="py-4 sm:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-center mb-4 sm:mb-6">
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight uppercase text-foreground">
            {t('findUs')} <span className="text-brand">{t('us')}</span>
          </h2>
          <p className="font-sans text-base sm:text-lg text-muted-foreground mt-4 max-w-xl mx-auto">{t('locationsDesc')}</p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 lg:gap-8">
          {locations.map((loc, i) => (
            <motion.a key={loc.name} href={loc.mapUrl} target="_blank" rel="noopener noreferrer" initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.15 }} data-testid={`location-card-${i}`} className="md:col-span-4 bg-card border border-border rounded-3xl p-8 sm:p-10 hover:border-brand/50 transition-colors duration-300 group block">
              <div className="w-12 h-12 rounded-2xl bg-brand/10 flex items-center justify-center mb-6 group-hover:bg-brand/20 transition-colors"><MapPin className="text-brand" size={24} /></div>
              <h3 className="font-heading text-2xl sm:text-3xl tracking-tight uppercase text-foreground mb-2">{loc.name}</h3>
              <p className="font-sans text-sm text-brand font-semibold mb-3">{loc.room}</p>
              <p className="font-sans text-muted-foreground leading-relaxed">{loc.address}</p>
              <p className="font-sans text-sm text-brand mt-4 group-hover:underline">{t('viewOnMaps')}</p>
            </motion.a>
          ))}
          <motion.div id="contact" initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }} data-testid="contact-card" className="md:col-span-4 bg-card border border-border rounded-3xl p-8 sm:p-10 hover:border-brand/50 transition-colors duration-300">
            <h3 className="font-heading text-2xl sm:text-3xl tracking-tight uppercase text-foreground mb-6">{t('getInTouch')} <span className="text-brand">{t('touch')}</span></h3>
            <div className="flex flex-col gap-5">
              {contacts.map(c => (
                <a key={c.label} href={c.href} target={c.href.startsWith('http') ? '_blank' : undefined} rel={c.href.startsWith('http') ? 'noopener noreferrer' : undefined} data-testid={`contact-${c.label.toLowerCase().replace(/[@.]/g, '-')}`} className="flex items-center gap-4 text-muted-foreground hover:text-brand transition-colors group">
                  <div className="w-10 h-10 rounded-xl bg-secondary flex items-center justify-center group-hover:bg-brand/10 transition-colors"><c.icon size={18} /></div>
                  <span className="font-sans text-sm font-medium">{c.label}</span>
                </a>
              ))}
            </div>
            <p className="font-sans text-xs text-muted-foreground mt-6">{t('confused')}</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
